import { jsonFetch } from "../common/json-fetch";
import { iexCloudApiToken } from "./api-tokens";

export function getIex<T>(path: string): Promise<T> {
  const url = new URL(`https://cloud.iexapis.com/stable${path}`);
  url.searchParams.append("token", iexCloudApiToken);
  return jsonFetch<T>(url.toString());
}
